module.exports = __webpack_public_path__ + "media/img/tab-icon-dev-9cc729c5.png";